import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';

type DashboardLinkProps = {
  // eslint-disable-next-line
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & { muiName: string };
  image?: string;
  title: string;
  to?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

export default function DashboardLink({ icon: Icon, image, title, to, onClick }: DashboardLinkProps) {
  return to ? (
    <Link to={to} target="_blank">
      <div className="flex items-center gap-2 px-4 py-3 bg-white rounded-full shadow-md overflow-hidden">
        {Icon && <Icon fontSize="medium" color="primary" />}
        {image && <img src={image} width={24} height={24} />}
        <p className="visible sm:invisible md:visible text-black font-semibold text-sm leading-none max-h-5 flex items-center">
          {title}
        </p>
      </div>
    </Link>
  ) : (
    <a className="cursor-pointer" onClick={onClick}>
      <div className="flex items-center gap-2 px-4 py-3 bg-white rounded-full shadow-md overflow-hidden">
        {Icon && <Icon fontSize="medium" color="primary" />}
        {image && <img src={image} width={24} height={24} />}
        <p className="visible sm:invisible md:visible text-black font-semibold text-sm leading-none max-h-5 flex items-center">
          {title}
        </p>
      </div>
    </a>
  );
}
